import type { FC } from "react";

import type { AuthFeatureData } from "~/core";
import { Button } from "~/shared/ui-kit";
import { Card } from "~/shared/ui-kit/card/Card";
import { Title } from "~/shared/ui-kit/title/Title";
import { Typography } from "~/shared/ui-kit/typography/Typography";

type RestoreData = ExtractArrayItemType<
  NonNullable<AuthFeatureData>["restore_password"]
>;
export type SuccessRestorePasswordFormProps = {
  data: RestoreData;
  onSubmit: () => void;
};

export const SuccessRestorePasswordForm: FC<
  SuccessRestorePasswordFormProps
> = ({ data, onSubmit }) => {
  return (
    <Card
      variant="secondary"
      className="min-w-[312px] max-w-[524px] min-h-[572px] md:min-h-[640px] rounded-2xl md:rounded-lg"
    >
      <form className="px-4 md:px-10 py-6 md:py-8 flex-grow flex flex-col w-full">
        <Title
          as="h2"
          size="small"
          weight="bold"
          className="text-center md:text-start pb-4 md:pb-6 m-0"
        >
          {data?.form_title}
        </Title>

        <Typography size="large" className="text-center md:text-start mb-3">
          {data?.description_text ??
            `An email has been sent to you with instructions for resetting your password`}
        </Typography>

        <Button
          type="button"
          size="small"
          md={{ size: "medium" }}
          weight="semibold"
          className="md:py-4 py-3 mt-auto w-full"
          onPress={onSubmit}
        >
          {data?.description_link_text}
        </Button>
      </form>
    </Card>
  );
};
